import styled from 'styled-components';

const Container = styled.div`
  margin-top: 4rem;
  align-self: center;

  .container {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;
  }

  .item {
    border-radius: var(--r-pill);
    transition: background-color var(--dur-fast) var(--ease-standard);

    :hover {
      background-color: var(--surface-2);
    }
  }

  .link {
    display: block;
    padding: 0.8rem 1.4rem;
    border-radius: var(--r-pill);
    font-size: 1.35rem;
    font-weight: 600;
    color: var(--ink-soft);
    cursor: pointer;
  }

  .item.active {
    background-color: var(--accent);
  }

  .link.active {
    color: #fff;
  }
`;

export default Container;
